import * as Ariakit from '@ariakit/react';

import type { ReactNode } from 'react';

import * as S from './RefactoredTooltip.styled';

interface TooltipPopoverProps extends Omit<Ariakit.TooltipProps<'div'>, 'render'> {}
export const TooltipPopover = ({ children, ...props }: TooltipPopoverProps) => (
  <Ariakit.Tooltip
    data-testid="TooltipPopover"
    portal
    gutter={0}
    render={<S.TooltipPopoverStyles />}
    {...props}
  >
    {children}
    <Ariakit.TooltipArrow />
  </Ariakit.Tooltip>
);

export const TooltipProvider = (props: Ariakit.TooltipProviderProps) => (
  <Ariakit.TooltipProvider showTimeout={0} {...props} />
);

export interface TooltipAnchorProps extends Ariakit.TooltipAnchorProps<'div'> {
  fitContent?: boolean;
}
export const TooltipAnchor = (props: TooltipAnchorProps) => (
  <Ariakit.TooltipAnchor render={<S.TooltipAnchorStyles />} {...props} />
);

export interface TooltipProps extends Omit<Ariakit.TooltipProps<'div'>, 'render' | 'content'> {
  content: ReactNode;
  fitContent?: boolean;
  provider?: Ariakit.TooltipProviderProps;
  anchor?: Ariakit.TooltipAnchorProps<'div'>;
}
export const Tooltip = ({
  children,
  content,
  anchor,
  provider,
  fitContent,
  ...props
}: TooltipProps) => (
  <TooltipProvider {...provider}>
    <TooltipAnchor fitContent={fitContent} {...anchor}>
      {children}
    </TooltipAnchor>
    {content && <TooltipPopover {...props}>{content}</TooltipPopover>}
  </TooltipProvider>
);
